import { executeQuery, QueryFetchPolicy, type QueryRef } from "firebase/data-connect";

// executeQuery defaults to PREFER_CACHE, which hands back the last result for the same query and variables
// without asking the server, so a table's refresh (or a repeated search) would show stale rows.
export function executeServerQuery<Data, Variables>(ref: QueryRef<Data, Variables>) {
  return executeQuery(ref, { fetchPolicy: QueryFetchPolicy.SERVER_ONLY });
}
